<template>
<!-- v-if="rows_count > 0"  -->
    <div class="container p-2 mt-0 mb-31 px-4">
        <div class="d-flex flex-column flex-sm-row align-items-center">
            <slot name="clear"></slot>

            <div class="d-flex flex-row align-items-center justify-content-center mb-3 mb-sm-0">
                <label class="text-nowrap">{{TR.row_per_page}}</label>
                <select
                    class="form-select ms-2"
                    style="width: 100px;"
                    @change="changePageRowCount($event)"
                >
                    <template v-for="(pc, ind) in page_row_count" :key="ind">
                        <option :value="pc" :selected="pc==pageRowCount ? true : false">{{pc}}</option>
                    </template>
                </select>
            </div>

            <slot name="content"></slot>

            <div
                class="ms-sm-auto me-sm-5 d-flex align-items-center justify-content-center mb-3 mb-sm-0"
            >
                <label class="text-nowrap fs-7">{{ TR.table_page_info ? $filters.replace($filters.replace(TR.table_page_info, '{totalPages}', pages_count), '{totalRecords}', rows_count) : '' }}</label>
            </div>

            <div
                class="d-flex flex-row align-items-center justify-content-center mb-3 mb-sm-0"
                v-if="pages_count > 5"
            >
                <label class="text-nowrap">{{TR.current_page}}</label>
                <input
                    id="toPage"
                    type="number"
                    min="1"
                    :max="pages_count"
                    class="form-control bg-transparent1 text-white1 border-secondary ms-2"
                    style="width: 85px;"
                    :value="currentPage"
                    @keyup="changePageOnEnter"
                />
                <button class="btn btn-secondary me-sm-3" @click="changePage()">
                    <i class="fas fa-angle-right"></i>
                </button>
            </div>

            <div>
                <nav v-if="pages_count > 1">
                    <ul
                        class="pagination d-flex align-items-center justify-content-center mt-2 mt-sm-0 mb-0"
                    >
                        <template v-if="pages_count > 5">
                            <li class="page-item" :class="currentPage == 1 ? 'disabled' : ''">
                                <a class="page-link" @click="changePage(1)">
                                    <i class="fas fa-angle-double-left"></i>
                                </a>
                            </li>
                            <li class="page-item" :class="currentPage == 1 ? 'disabled' : ''">
                                <a class="page-link" @click="changePage(start == 0 ? 1 : start)">
                                    <i class="fas fa-angle-left"></i>
                                </a>
                            </li>
                        </template>

                        <li
                            v-for="(pg, index) in pages"
                            :key="index"
                            class="page-item"
                            :class="currentPage == pg ? 'active' : ''"
                        >
                            <a class="page-link" @click="changePage(pg)">{{pg}}</a>
                        </li>

                        <template v-if="pages_count > 5">
                            <li
                                class="page-item"
                                :class="currentPage >= pages_count ? 'disabled' : ''"
                            >
                                <a class="page-link" @click="changePage( end < pages_count ? (end+1) : end )">
                                    <i class="fas fa-angle-right"></i>
                                </a>
                            </li>
                            <li
                                class="page-item"
                                :class="currentPage >= pages_count ? 'disabled' : ''"
                            >
                                <a class="page-link" @click="changePage(pages_count)">
                                    <i class="fas fa-angle-double-right"></i>
                                </a>
                            </li>
                        </template>
                    </ul>
                </nav>
            </div>

        </div>
    </div>
</template>

<script >
    import { ref, watchEffect } from "vue";
    import { useRoute, useRouter } from "vue-router";

    import { useStore } from "@/system_modules/store";

    export default {
        name: 'PaginationC',
        props: {
            pages_count: {
                type: Number,
                default: 1
            },
            rows_count: {
                type: Number,
                default: 1
            },
            route_name: {
                type: String
            },
            route_obj: {
                type: Object,
                default: () => {}
            },
        },
        setup(props) {
            const store = useStore();
            const route = useRoute();
            const router = useRouter();

            const TR = ref({});
            const currentPage = ref(1);
            const pages = ref([]);
            const pageRowCount = ref(20);

            const page_row_count = [4, 8, 16, 20, 50, 100];
            const start = ref(0);
            const end = ref(0);

            watchEffect(() => {
                TR.value = store.getTranslation();
                currentPage.value = route.params.page || 1;

                currentPage.value = parseInt(
                    route.params.page || 1
                );
                pageRowCount.value = parseInt(
                    route.params.perpage || 20
                );

                let page_count = props.pages_count;
                let pagesl = [];

                if (page_count > 5) {
                    start.value = parseInt(Math.floor(Math.abs(currentPage.value - 1) / 5)) * 5;
                    end.value = start.value + 5;
                    if (end.value > page_count) end.value = page_count;
                } else {
                    start.value = 0;
                    end.value = page_count;
                }
                for (let i = start.value + 1; i <= end.value; i++) {
                    pagesl.push(i);
                }
                pages.value = pagesl;
            });

            const changePageOnEnter = (e) => {
                if (e.which == 13) {
                    changePage();
                }
            };

            const changePage = (page) => {
                let cp;
                if (page === undefined && document.getElementById("toPage"))
                    cp = parseInt(document.getElementById("toPage").value);
                else cp = page;

                router.push({
                    name: props.route_name,
                    params: Object.assign(
                        props.route_obj,
                        {
                            page: cp,
                            perpage: pageRowCount.value,
                        },
                    ),
                    // query: props.route_obj.query
                });
            };

            const changePageRowCount = (event) => {
                let sel_row_count = parseInt(event.target.value);
                router.push({
                    name: props.route_name,
                    params: Object.assign(
                        props.route_obj,
                        {
                            page: 1,
                            perpage: sel_row_count,
                        },
                    ),
                    // query: props.route_obj.query
                });
            };

            // const createPageRange = async (cp) => {
            //     let page_count = props.pages_count;
            //     let pagesl = [];

            //     // let arr = Array.apply(null, Array(page_count)).map((a, i)=>i+1)

            //     if (page_count > 5) {
            //         start.value = parseInt(Math.floor(Math.abs(cp - 1) / 5)) * 5;
            //         end.value = start.value + 5;
            //         if (end.value > page_count) end.value = page_count;
            //     } else {
            //         start.value = 0;
            //         end.value = page_count;
            //     }
            //     for (let i = start.value + 1; i <= end.value; i++) {
            //         pagesl.push(i);
            //     }
            //     pages.value = pagesl;
            // };

            // onMounted(async () => {
            //     // currentPage.value = parseInt(
            //     //     route.params.page
            //     // );
            //     // pageRowCount.value = parseInt(
            //     //     route.params.perpage || 20
            //     // );
            //     // await createPageRange(currentPage.value);
            // });

            return {
                TR,
                changePage,
                changePageOnEnter,
                pages,
                currentPage,
                changePageRowCount,
                pageRowCount,
                page_row_count,
                start,
                end
            };
        },
    };
</script>

<style lang="scss" scoped1>
    .page-item.active .page-link {
        background: #51535199;
    }
    .page-link {
        color: #fff;
        background-color: #ffffff40;
        border: 0;
        cursor: pointer;
        // padding: 7px 15px;
    }
    .page-item.disabled .page-link {
        background-color: #bdbcbc50;
    }
</style>
